import { getConfiguration } from '@chr/common-web-ui-configuration';
import { AppConfig } from './react-app-env';
import { datadogRum } from '@datadog/browser-rum';

export const index: Promise<void> = (async () => {
  const config: AppConfig = await getConfiguration();

  try {
    const environment = config.environment;
    if (environment && environment !== 'local') {
      datadogRum.init({
        applicationId: 'bc160d93-5b4f-44bd-9453-3e18dd993681',
        clientToken: 'pub1a40b2d850bedeeddbd83c9106359cfe',
        site: 'us3.datadoghq.com',
        service: 'online.gf.bookingcreate.ui',
        env: environment,
        version: '1.0.0',
        sessionSampleRate: 25,
        sessionReplaySampleRate: 5,
        trackResources: true,
        trackLongTasks: true,
        trackUserInteractions: true,
        defaultPrivacyLevel: 'mask-user-input',
        useSecureSessionCookie: true,
        allowedTracingUrls: [
          /https?:\/\/.*\.chrobinson.com/,
          /https?:\/\/.*inavisphere/
        ]
      })
  }
  } catch { 
    // Do not block loading for a datadog error
  }

  datadogRum.startSessionReplayRecording();

    const { bootstrap } = await import('./bootstrap');
    bootstrap(config);

})();
